import React from 'react'
import { Box, Container } from "@mui/material";
import { CLIQLOAN_BRAND } from './theme/cliqloanBrand';
import { CLIQLOAN_TYPO } from './theme/cliqloanTypography';
import BannerMain from './components/banner/new-banner';
import MainComponentFinal from './components/pagination/MainComponentFinal';
import BlogSeo from './components/BlogSeo';
import { getSortedBlogPosts } from './blogs/blogConfig';

export default function Home() {
    const firstArticleImage = getSortedBlogPosts()[0].image.replace(/\.png$/i, '.avif');

    return (
        <Box sx={{ backgroundColor: CLIQLOAN_BRAND.pageBg, minHeight: '100vh' }}>
            <BlogSeo
                title="CliQloan Blog | Mortgage Origination Insights"
                description="Practical articles on mortgage origination, document collection, borrower experience and loan team collaboration from the CliQloan team."
                canonicalPath="/blog/"
                image="https://www.cliqloan.com/images/social/cliqloan-social-1200x630.png"
                imageAlt="Cliqloan social preview"
                preloadImage={firstArticleImage}
                type="website"
            />
            <BannerMain />
            <Container
                maxWidth="lg"
                sx={{
                    px: { xs: 2, sm: 3, md: CLIQLOAN_TYPO.pagePadding },
                    pb: { xs: 6, md: 8 },
                }}
            >
                <Box marginY={2}>
                    <MainComponentFinal />
                </Box>
            </Container>
        </Box>
    )
}
